import { type FC, type PropsWithChildren, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { UserInfoContext } from '@/contexts/UserInfoContext';

/**
 * Route guard that requires the user to have the token_admin role.
 * Redirects to home if the user is not a token admin and token usage tracking is enabled.
 */
export const RequireTokenAdmin: FC<PropsWithChildren> = ({ children }) => {
  const { userInfo } = useContext(UserInfoContext);
  const navigate = useNavigate();
  const isTokenAdmin = !!userInfo?.isTokenAdmin;
  const enableTokenUsageTracking = !!userInfo?.features?.tokenUsageTracking;

  useEffect(() => {
    if (enableTokenUsageTracking && !isTokenAdmin) {
      navigate('/', { replace: true });
    }
  }, [enableTokenUsageTracking, isTokenAdmin, navigate]);

  if (enableTokenUsageTracking && !isTokenAdmin) {
    return null;
  }

  return <>{children}</>;
};
